import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="8" cy="8" fill="#EAF6ED" r="7" />
        <circle cx="8" cy="7" fill="#3EA966" r="3" />
        <path
            d="M7.5 14C5.96631 14 4.53063 13.3139 3.6439 12.6182C3.24301 12.3037 3.26989 11.7238 3.65937 11.3952C4.73447 10.4882 6.32668 9.5 8 9.5C9.27577 9.5 11.2749 10.5851 12.4593 11.5247C12.7965 11.7922 12.8668 12.2695 12.5353 12.5441C11.5829 13.3332 9.54143 14 7.5 14Z"
            fill="#3EA966"
            stroke="#3EA966"
            strokeLinecap="round"
        />
        <path
            clipRule="evenodd"
            d="M13.0908 11.1771C13.667 10.2558 14 9.16677 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 9.16677 2.33304 10.2558 2.90924 11.1771C3.68395 10.0724 4.82151 9.49641 5.98312 9.22088C5.37918 8.67209 5 7.88032 5 7C5 5.34315 6.34315 4 8 4C9.65685 4 11 5.34315 11 7C11 7.88032 10.6208 8.67209 10.0169 9.22088C11.1785 9.49641 12.3161 10.0724 13.0908 11.1771ZM12.4474 12.0276C11.5381 10.4516 9.71318 10 8 10C6.28682 10 4.46192 10.4516 3.55261 12.0276C4.65041 13.2391 6.23634 14 8 14C9.76366 14 11.3496 13.2391 12.4474 12.0276ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
            fill="#2C5E40"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
